// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-content {
  --padding-top: 0;
  --padding-bottom: 0;
  --padding-start: 0;
  --padding-end: 0;
  height: 100vh;
  --overflow: hidden;
}

.reishauer-header {
  background: var(--bg-primary);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  justify-content: flex-end;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 15px;
}
.reishauer-header .logo-wrapper {
  cursor: pointer;
}
.reishauer-header .back-selector {
  width: 24px;
  height: 24px;
  cursor: pointer;
}

.time-selection {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px 24px 30px;
  background: linear-gradient(135deg, #f9f9f9 0%, #f3f3f3 100%);
}
.time-selection .time-selection-text-block {
  flex-grow: 1;
  text-align: center;
  max-width: 600px;
}
.time-selection .time-selection-text {
  font-family: AppFontBold, Helvetica, sans-serif;
  font-size: 28px;
  line-height: 120%;
  letter-spacing: 1%;
  font-weight: 700;
  margin-bottom: 8px;
  color: #2c2c2c;
}
.time-selection .time-selection-text.accent {
  color: var(--ion-color-primary);
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 0;
}

.header {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 30px 0 20px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.3019607843);
}

.logo {
  --icon-color: black;
  height: 36px;
  width: 85px;
  margin-bottom: 20px;
}

.title {
  font-family: Title;
  font-size: 32px;
  line-height: 110%;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;
  text-transform: uppercase;
  vertical-align: baseline;
}
.title.accent {
  color: #c6a475;
}

.container-all {
  min-height: 100vh;
}
.container-all .wrapper-left {
  display: flex;
  justify-content: center;
  align-self: center;
  width: 100%;
  height: 100%;
  overflow: auto;
  background: #faf7f6;
}
.container-all .wrapper-left ion-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.container-all.wrapper-info {
  overflow: auto;
  background: #f9f9f9;
  width: 100%;
  display: block;
}
.container-all.wrapper-info ion-button {
  width: 100%;
}
.container-all.wrapper-info .main-card {
  margin: 0 24px 40px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(0, 0, 0, 0.05);
}
.container-all.wrapper-info ion-card {
  text-align: initial;
  border: none;
  box-shadow: none;
  background: transparent;
  --color: var(--color-black);
  --preorder-type-chip-border-color: var(--ion-color-primary);
  overflow: auto;
  word-break: break-word;
}
.container-all.wrapper-info ion-card ion-card-header {
  background: white;
  color: var(--color-black);
  padding: 0;
  padding-bottom: 8px;
  border-bottom: 0.3px solid rgba(126, 167, 105, 0.4509803922);
}
.container-all.wrapper-info ion-card ion-card-header .separator {
  margin-block: 20px;
}
.container-all.wrapper-info ion-card ion-card-header ion-button {
  --background: transparent;
  --color: #54504c;
  text-transform: none;
}
.container-all.wrapper-info ion-card ion-card-content {
  border-top: 0.3px solid rgba(126, 167, 105, 0.4509803922);
  padding: 10px 0px 0px 0px;
  line-break: auto !important;
}
.container-all.wrapper-info ion-card ion-card-content:first-of-type {
  border: none;
}
.container-all.wrapper-info ion-card ion-card-content .padding-card {
  padding: 10px;
}
.container-all.wrapper-info ion-card ion-card-title {
  font-family: AppFontBold, sans-serif;
  color: var(--color-black);
  font-size: 18px;
}
.container-all.wrapper-info ion-card .icon-edit {
  zoom: 1.3;
}
.container-all.wrapper-info ion-card .left-col {
  text-align: left;
}
.container-all.wrapper-info ion-card .right-col {
  text-align: right;
}

.item-row {
  padding: 20px 24px;
  border-bottom: 1px solid #f0f0f0;
}
.item-row:last-child {
  border-bottom: none;
  border-radius: 0 0 12px 12px;
}
.item-row:first-child {
  border-radius: 12px 12px 0 0;
}

.article-price,
.article-name {
  margin-bottom: 10px;
}

.article-name {
  padding: 0;
  font-family: AppFontBold, Helvetica, sans-serif;
  font-size: 16px;
  line-height: 120%;
  letter-spacing: 2%;
  vertical-align: middle;
  text-transform: uppercase;
}

.article-price {
  padding: 0;
  font-family: AppFontBold, Helvetica, sans-serif;
  font-size: 16px;
  line-height: 120%;
  letter-spacing: 2%;
  vertical-align: middle;
  text-transform: uppercase;
}

.option-block {
  padding: 0;
}

.option-name {
  font-family: AppFont, Helvetica, sans-serif;
  font-size: 10px;
  line-height: 120%;
  letter-spacing: 0%;
  vertical-align: bottom;
  text-transform: uppercase;
  margin-bottom: 3px;
}

.footer {
  margin: 0 24px 30px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.table-row {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 18px;
  border-bottom: 1px solid #dce8f5;
}
.table-row .table-title,
.table-row .table-sum {
  font-family: AppFontBold, Helvetica, sans-serif;
  font-size: 14px;
  line-height: 120%;
  letter-spacing: 0%;
  text-align: right;
  vertical-align: bottom;
  text-transform: uppercase;
}

.total-row {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0;
  padding: 10px 18px;
  border-bottom: 1px solid #dce8f5;
}
.total-row .total {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0;
  width: 100%;
}
.total-row .total-title,
.total-row .total-sum {
  font-family: AppFontBold, Helvetica, sans-serif;
  font-size: 14px;
  line-height: 120%;
  letter-spacing: 0%;
  text-align: right;
  vertical-align: bottom;
  text-transform: uppercase;
}

.sub-total {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0;
  margin-bottom: 8px;
}
.sub-total .sub-total-title,
.sub-total .sub-total-sum {
  font-family: AppFont, Helvetica, sans-serif;
  font-size: 10px;
  line-height: 120%;
  letter-spacing: 8%;
  vertical-align: middle;
  text-transform: uppercase;
}

.button-block {
  width: 100%;
  padding: 25px 14px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 15px;
}
.button-block ion-button {
  width: 100%;
  min-height: 54px;
  font-size: 17px;
  --background: #2d69aa;
}
.button-block ion-button.transparent {
  --background: transparent;
  --color: #2d69aa;
  --border-color: #2d69aa;
  --border-width: 1px;
  --border-style: solid;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/payment-success/payment-success.page.scss"],"names":[],"mappings":"AAGA;EACC,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,kBAAA;AAFD;;AAMA;EACC,6BAAA;EACA,iDAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;AAHD;AAKC;EACC,eAAA;AAHF;AAMC;EACC,WAAA;EACA,YAAA;EACA,eAAA;AAJF;;AAaA;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,uBAAA;EACA,6DAAA;AAVD;AAYC;EACC,YAAA;EACA,kBAAA;EACA,gBAAA;AAVF;AAaC;EACC,+CAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;AAXF;AAaE;EACC,+BAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AAXH;;AAgBA;EACC,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,oDAAA;AAbD;;AAgBA;EACC,mBAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;AAbD;;AAgBA;EACC,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;EACA,wBAAA;AAbD;AAeC;EACC,cAAA;AAbF;;AAiBA;EACC,iBAAA;AAdD;AAeC;EACC,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;AAbF;AAcE;EACC,WAAA;EACA,YAAA;EACA,iBAAA;AAZH;AAkBC;EACC,cAAA;EACA,mBAAA;EAKA,WAAA;EACA,cAAA;AApBF;AAeE;EACC,WAAA;AAbH;AAmBE;EACC,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,0CAAA;EACA,qCAAA;AAjBH;AAoBE;EACC,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,2BAAA;EACA,2DAAA;EACA,cAAA;EACA,sBAAA;AAlBH;AAmBG;EACC,iBAAA;EACA,yBAAA;EACA,UAAA;EACA,mBAAA;EAIA,4DAAA;AApBJ;AAiBI;EACC,kBAAA;AAfL;AAmBI;EACC,yBAAA;EACA,gBAAA;EACA,oBAAA;AAjBL;AAoBG;EACC,yDAAA;EAEA,yBAAA;EACA,2BAAA;AAnBJ;AAoBI;EACC,YAAA;AAlBL;AAoBI;EACC,aAAA;AAlBL;AAqBG;EACC,oCAAA;EACA,yBAAA;EACA,eAAA;AAnBJ;AAqBG;EACC,SAAA;AAnBJ;AAuBG;EACC,gBAAA;AArBJ;AAwBG;EACC,iBAAA;AAtBJ;;AA4BA;EACC,kBAAA;EACA,gCAAA;AAzBD;AA2BC;EACC,mBAAA;EACA,4BAAA;AAzBF;AA4BC;EACC,4BAAA;AA1BF;;AA8BA;;EAEC,mBAAA;AA3BD;;AA8BA;EACC,UAAA;EAEA,+CAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;AA5BD;;AA+BA;EACC,UAAA;EAEA,+CAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;AA7BD;;AA+BA;EACC,UAAA;AA5BD;;AA+BA;EACC,2CAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;AA5BD;;AA+BA;EACC,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,0CAAA;EACA,qCAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AA5BD;;AA+BA;EACC,WAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,gCAAA;AA5BD;AA6BC;;EAEC,+CAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;EACA,yBAAA;AA3BF;;AA+BA;EACC,WAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;EACA,kBAAA;EACA,gCAAA;AA5BD;AA8BC;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,UAAA;EACA,WAAA;AA5BF;AA+BC;;EAEC,+CAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;EACA,yBAAA;AA7BF;;AAiCA;EACC,WAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,UAAA;EACA,kBAAA;AA9BD;AA+BC;;EAEC,2CAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;AA7BF;;AAiCA;EACC,WAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;AA9BD;AAgCC;EACC,WAAA;EACA,gBAAA;EACA,eAAA;EACA,qBAAA;AA9BF;AAgCE;EACC,yBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,qBAAA;AA9BH","sourcesContent":["@import '../../../theme/mixins';\n\n// Remove default ion-content padding and make full height\nion-content {\n\t--padding-top: 0;\n\t--padding-bottom: 0;\n\t--padding-start: 0;\n\t--padding-end: 0;\n\theight: 100vh;\n\t--overflow: hidden; // Remove scrollbar when not needed\n}\n\n// Reishauer header styles\n.reishauer-header {\n\tbackground: var(--bg-primary);\n\tborder-bottom: 1px solid rgba(255, 255, 255, 0.1);\n\tjustify-content: flex-end;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tpadding: 10px 15px;\n\n\t.logo-wrapper {\n\t\tcursor: pointer;\n\t}\n\n\t.back-selector {\n\t\twidth: 24px;\n\t\theight: 24px;\n\t\tcursor: pointer;\n\t}\n}\n\n.wrapper-info {\n\t// background: #faf7f6;\n}\n\n// Professional title section with better spacing\n.time-selection {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tpadding: 40px 24px 30px;\n\tbackground: linear-gradient(135deg, #f9f9f9 0%, #f3f3f3 100%);\n\n\t.time-selection-text-block {\n\t\tflex-grow: 1;\n\t\ttext-align: center;\n\t\tmax-width: 600px;\n\t}\n\n\t.time-selection-text {\n\t\tfont-family: AppFontBold, Helvetica, sans-serif;\n\t\tfont-size: 28px;\n\t\tline-height: 120%;\n\t\tletter-spacing: 1%;\n\t\tfont-weight: 700;\n\t\tmargin-bottom: 8px;\n\t\tcolor: #2c2c2c;\n\n\t\t&.accent {\n\t\t\tcolor: var(--ion-color-primary);\n\t\t\tfont-size: 24px;\n\t\t\tfont-weight: 600;\n\t\t\tmargin-bottom: 0;\n\t\t}\n\t}\n}\n\n.header {\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n\talign-items: center;\n\tpadding: 30px 0 20px;\n\tborder-bottom: 1px solid #0000004d;\n}\n\n.logo {\n\t--icon-color: black;\n\theight: 36px;\n\twidth: 85px;\n\tmargin-bottom: 20px;\n}\n\n.title {\n\tfont-family: Title;\n\tfont-size: 32px;\n\tline-height: 110%;\n\tletter-spacing: 0%;\n\ttext-align: center;\n\tvertical-align: middle;\n\ttext-transform: uppercase;\n\tvertical-align: baseline;\n\n\t&.accent {\n\t\tcolor: #c6a475;\n\t}\n}\n\n.container-all {\n\tmin-height: 100vh;\n\t.wrapper-left {\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-self: center;\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\toverflow: auto;\n\t\tbackground: #faf7f6;\n\t\tion-img {\n\t\t\twidth: 100%;\n\t\t\theight: 100%;\n\t\t\tobject-fit: cover;\n\t\t}\n\t\t// background: url('') no-repeat center center / 105% 105%;\n\t\t// background-size: cover;\n\t\t// background-position: center;\n\t}\n\t&.wrapper-info {\n\t\toverflow: auto;\n\t\tbackground: #f9f9f9;\n\t\tion-button {\n\t\t\twidth: 100%;\n\t\t}\n\n\t\twidth: 100%;\n\t\tdisplay: block;\n\n\t\t.main-card {\n\t\t\tmargin: 0 24px 40px;\n\t\t\tbackground: #fff;\n\t\t\tborder-radius: 12px;\n\t\t\tbox-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);\n\t\t\tborder: 1px solid rgba(0, 0, 0, 0.05);\n\t\t}\n\n\t\tion-card {\n\t\t\ttext-align: initial;\n\t\t\tborder: none;\n\t\t\tbox-shadow: none;\n\t\t\tbackground: transparent;\n\t\t\t--color: var(--color-black);\n\t\t\t--preorder-type-chip-border-color: var(--ion-color-primary);\n\t\t\toverflow: auto;\n\t\t\tword-break: break-word;\n\t\t\tion-card-header {\n\t\t\t\tbackground: white;\n\t\t\t\tcolor: var(--color-black);\n\t\t\t\tpadding: 0;\n\t\t\t\tpadding-bottom: 8px;\n\t\t\t\t.separator {\n\t\t\t\t\tmargin-block: 20px;\n\t\t\t\t}\n\t\t\t\tborder-bottom: 0.3px solid #7ea76973;\n\n\t\t\t\tion-button {\n\t\t\t\t\t--background: transparent;\n\t\t\t\t\t--color: #54504c;\n\t\t\t\t\ttext-transform: none;\n\t\t\t\t}\n\t\t\t}\n\t\t\tion-card-content {\n\t\t\t\tborder-top: 0.3px solid #7ea76973;\n\n\t\t\t\tpadding: 10px 0px 0px 0px;\n\t\t\t\tline-break: auto !important;\n\t\t\t\t&:first-of-type {\n\t\t\t\t\tborder: none;\n\t\t\t\t}\n\t\t\t\t.padding-card {\n\t\t\t\t\tpadding: 10px;\n\t\t\t\t}\n\t\t\t}\n\t\t\tion-card-title {\n\t\t\t\tfont-family: AppFontBold, sans-serif;\n\t\t\t\tcolor: var(--color-black);\n\t\t\t\tfont-size: 18px;\n\t\t\t}\n\t\t\t.icon-edit {\n\t\t\t\tzoom: 1.3;\n\t\t\t}\n\t\t\tion-col {\n\t\t\t}\n\t\t\t.left-col {\n\t\t\t\ttext-align: left;\n\t\t\t}\n\n\t\t\t.right-col {\n\t\t\t\ttext-align: right;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.item-row {\n\tpadding: 20px 24px;\n\tborder-bottom: 1px solid #f0f0f0;\n\n\t&:last-child {\n\t\tborder-bottom: none;\n\t\tborder-radius: 0 0 12px 12px;\n\t}\n\n\t&:first-child {\n\t\tborder-radius: 12px 12px 0 0;\n\t}\n}\n\n.article-price,\n.article-name {\n\tmargin-bottom: 10px;\n}\n\n.article-name {\n\tpadding: 0;\n\n\tfont-family: AppFontBold, Helvetica, sans-serif;\n\tfont-size: 16px;\n\tline-height: 120%;\n\tletter-spacing: 2%;\n\tvertical-align: middle;\n\ttext-transform: uppercase;\n}\n\n.article-price {\n\tpadding: 0;\n\n\tfont-family: AppFontBold, Helvetica, sans-serif;\n\tfont-size: 16px;\n\tline-height: 120%;\n\tletter-spacing: 2%;\n\tvertical-align: middle;\n\ttext-transform: uppercase;\n}\n.option-block {\n\tpadding: 0;\n}\n\n.option-name {\n\tfont-family: AppFont, Helvetica, sans-serif;\n\tfont-size: 10px;\n\tline-height: 120%;\n\tletter-spacing: 0%;\n\tvertical-align: bottom;\n\ttext-transform: uppercase;\n\tmargin-bottom: 3px;\n}\n\n.footer {\n\tmargin: 0 24px 30px;\n\tbackground: #fff;\n\tborder-radius: 12px;\n\tbox-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);\n\tborder: 1px solid rgba(0, 0, 0, 0.05);\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n\talign-items: center;\n}\n\n.table-row {\n\twidth: 100%;\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\tpadding: 10px 18px;\n\tborder-bottom: 1px solid #dce8f5;\n\t.table-title,\n\t.table-sum {\n\t\tfont-family: AppFontBold, Helvetica, sans-serif;\n\t\tfont-size: 14px;\n\t\tline-height: 120%;\n\t\tletter-spacing: 0%;\n\t\ttext-align: right;\n\t\tvertical-align: bottom;\n\t\ttext-transform: uppercase;\n\t}\n}\n\n.total-row {\n\twidth: 100%;\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n\talign-items: center;\n\tpadding: 0;\n\tpadding: 10px 18px;\n\tborder-bottom: 1px solid #dce8f5;\n\n\t.total {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\talign-items: center;\n\t\tpadding: 0;\n\t\twidth: 100%;\n\t}\n\n\t.total-title,\n\t.total-sum {\n\t\tfont-family: AppFontBold, Helvetica, sans-serif;\n\t\tfont-size: 14px;\n\t\tline-height: 120%;\n\t\tletter-spacing: 0%;\n\t\ttext-align: right;\n\t\tvertical-align: bottom;\n\t\ttext-transform: uppercase;\n\t}\n}\n\n.sub-total {\n\twidth: 100%;\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\tpadding: 0;\n\tmargin-bottom: 8px;\n\t.sub-total-title,\n\t.sub-total-sum {\n\t\tfont-family: AppFont, Helvetica, sans-serif;\n\t\tfont-size: 10px;\n\t\tline-height: 120%;\n\t\tletter-spacing: 8%;\n\t\tvertical-align: middle;\n\t\ttext-transform: uppercase;\n\t}\n}\n\n.button-block {\n\twidth: 100%;\n\tpadding: 25px 14px;\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n\talign-items: center;\n\tgap: 15px;\n\n\tion-button {\n\t\twidth: 100%;\n\t\tmin-height: 54px;\n\t\tfont-size: 17px;\n\t\t--background: #2d69aa;\n\n\t\t&.transparent {\n\t\t\t--background: transparent;\n\t\t\t--color: #2d69aa;\n\t\t\t--border-color: #2d69aa;\n\t\t\t--border-width: 1px;\n\t\t\t--border-style: solid;\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
